
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/schools/upload-vacancy/thank-you",
      function () {
        return require("private-next-pages/schools/upload-vacancy/thank-you/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/schools/upload-vacancy/thank-you"])
      });
    }
  